import React, {forwardRef, useImperativeHandle, useState} from "react";
import SpinnerButton from "../../components/common/SpinnerButton";
import {IconButton, Modal, TextField, Typography} from "@mui/material";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";

const VerifyMFAModal = forwardRef(function VerifyMFAModal({handleVerifyOtp}, ref) {
        const [otp, setOtp] = useState({verified: false, code: ""});
        const [message, setMessage] = useState({success: null, failure: null});
        const [isModalOpen, setIsModalOpen] = useState(false)
        useImperativeHandle(ref, () => {
            return {
                open() {
                    setIsModalOpen(true)
                },
                close() {
                    setIsModalOpen(false)
                }
            }
        })
        const handleChange = async (value) => {
            if (/^\d*$/.test(value)) {
                setOtp(prev => {
                        return {
                            ...prev,
                            code: value,
                        }
                    }
                )
                handleSetMessage('error', "")
            } else {
                handleSetMessage('error', "OTP code must contain numbers")
            }
        }
        const handleSetMessage = (type, message) => {
            setMessage(
                prevState => (
                    {
                        ...prevState,
                        [type]: message,
                    }
                )
            )
        }

        const doValidateInput = () => {
            if (otp.code.length === 0) {
                handleSetMessage('error', "OTP cannot be empty.");
            } else if (otp.code.length !== 6) {
                handleSetMessage('error', "OTP must be 6 digits.");
            } else {
                handleSetMessage('error', "");
            }
        }

        const confirmOtp = async () => {
            try {
                const {success, nextStep} = await handleVerifyOtp(otp.code)
                console.log(`Verify OTP response - ${success}`)
                if (success) {
                    handleSetMessage('success', "OTP verification successful!")
                    setTimeout(
                        () => {
                            nextStep()
                        }, 1000
                    );
                } else {
                    handleSetMessage('success', "")
                    handleSetMessage('error', "OTP verification failed!")
                }
            } catch (err) {
                handleSetMessage('success', "")
                handleSetMessage('error', "Something went wrong with OTP verification!")
            }
        }

        const handleOnModalClose = () => {
            handleSetMessage('success', "")
            handleSetMessage('error', "")
            setIsModalOpen(false)
        }

        return (
            <Modal
                open={isModalOpen}
                onClose={handleOnModalClose}
                aria-labelledby="verifymfa-modal-title"
                aria-describedby="verifymfa-modal-description"
             >
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: 450,
                        bgcolor: "rgba(224, 224, 224, 1)",
                        boxShadow: 24,
                        borderRadius: 2,
                        p: 4,
                    }}
                >
                    {/* Modal Header */}
                    <Box sx={{display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2}}>
                        <Typography id="verifymfa-modal-title" variant="h6" component="h2">
                            Verify OTP
                        </Typography>
                        <IconButton onClick={handleOnModalClose}>
                            <CloseIcon/>
                        </IconButton>
                    </Box>
                    <p>Enter the code from your authenticator app</p>
                    {message.success && <p style={{color: "green"}}>{message.success}</p>}
                    {message.error && <p style={{color: "red"}}>{message.error}</p>}
                    <Box sx={{display: "flex", flexDirection: "column", gap: 2, mt: 2}}>
                        <TextField
                            name="mfaCode"
                            placeholder={"Enter 6-digit code"}
                            mandatory={true}
                            type="text"
                            value={otp.code}
                            onChange={(e) => handleChange(e.target.value)}
                            fullWidth
                            onBlur={doValidateInput}
                        />
                    </Box>

                    <SpinnerButton
                        label="Confirm"
                        className="btn-block"
                        onClick={confirmOtp}
                        buttonColor={"#001645"}
                    />
                </Box>
            </Modal>
        )
    }
);

export default VerifyMFAModal;